const lang = window.lang || $("html").attr("lang") || "de";
window.handheld =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
window.localStorageSupport = typeof localStorage !== "undefined";
const $wrapper = $("body #wrp").length > 0 ? $("#wrp") : $("body");

let timeNow = new Date().getTime();
if (
  (window.localStorageSupport && localStorage.getItem("init") == null) ||
  localStorage.getItem("init") + 2592000000 < timeNow
) {
  localStorage.clear();
  try {
    localStorage.setItem("init", timeNow);
  } catch (error) {
    console.log(error);
  }
}

/* Avoid form resubmission on refresh */
if (window.history.replaceState) {
  window.history.replaceState(null, null, window.location.href);
}

if (typeof window.amountToHuman === "undefined") {
  window.amountToHuman = function (amount, avoidCurrency) {
    if (!avoidCurrency) {
      return new Intl.NumberFormat(lang == "de" ? "de-DE" : "en-GB", {
        style: "currency",
        currency: "EUR",
      }).format(amount);
    } else {
      return new Intl.NumberFormat(lang == "de" ? "de-DE" : "en-GB").format(
        amount
      );
    }
  };
}
if (typeof window.slugify === "undefined") {
  window.slugify = function (string) {
    let a =
      "àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;";
    let b =
      "aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------";
    let p = new RegExp(a.split("").join("|"), "g");

    return string
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, "-and-") // Replace & with 'and'
      .replace(/[^\w\-]+/g, "") // Remove all non-word characters
      .replace(/\-\-+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, ""); // Trim - from end of text
  };
}

if (
  window.localStorageSupport &&
  typeof window.saveRentalNavigationItems === "undefined"
) {
  window.saveRentalNavigationItems = function (items, url) {
    try {
      localStorage.setItem(
        "search",
        typeof url !== "undefined"
          ? url
          : window.location.href.replace(window.location.hash, "")
      );
      if (typeof items !== "undefined" && items != null) {
        localStorage.setItem("items", items);
      }
      localStorage.setItem("init", timeNow);
    } catch (error) {
      console.log(error);
    }
  };
}
if (
  window.localStorageSupport &&
  typeof window.saveSearchParams === "undefined"
) {
  window.saveSearchParams = function (params) {
    try {
      localStorage.setItem("search-params", params);
      localStorage.setItem("init", timeNow);
    } catch (error) {
      console.log(error);
    }
  };
}

if (typeof window.dispatchCBEvent === "undefined") {
  window.dispatchCBEvent = function (elem, eventName) {
    var event;
    if (typeof Event === "function") {
      event = new Event(eventName);
    } else {
      event = document.createEvent("Event");
      event.initEvent(eventName, true, true);
    }

    elem.dispatchEvent(event);
  };
}

$(function () {
  $(".dropdown").on("click", ".dropdown-toggle:not(.open)", function (e) {
    $(".dropdown-toggle.open").removeClass("open");
  });
});
